import FilterButton from '@components/button/FilterButton'
import React from 'react'
import { useTheme } from 'styled-components'

const DynastyFilter = ({ dynastiesList, dynastyValue, handleDynastyChange }) => {
  const theme = useTheme()

  return (
    <>
      <h3>Dynasties</h3>
      {dynastiesList?.map(dyn => {
        return (
          <FilterButton
            key={`dynasty_filter_${dyn.slug}`}
            active={dynastyValue === dyn.slug}
            styles={{
              border: dynastyValue?.includes(dyn.slug) ? `3px solid ${theme.colors.gold}` : '',
            }}
            onClick={e => {
              Test(dyn.name)
            }}
            onClick={() => handleDynastyChange(dyn.slug)}
          >
            {dyn.name}
          </FilterButton>
        )
      })}
    </>
  )
}

export default DynastyFilter
